/**
 * 工作流配置
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
	async getFormDetail(keyId) {
		return request(api.workflow.WORK_FLOW + "/" + keyId, METHOD.GET);
	},
	async saveFormDetail(result) {
		return request(api.workflow.WORK_FLOW, METHOD.PUT, result);
	},
	async addSaveFormDetail(result) {
		return request(api.workflow.WORK_FLOW, METHOD.POST, result);
	},
	async deleteRow(keyId) {
		return request(api.workflow.WORK_FLOW + "/" + keyId, METHOD.DELETE);
	},
	async getProcess() {
		return request(api.modulePaths.WORKFLOW + "/act/process/processDrop", METHOD.GET);
	},

	/**
	 * 审批记录
	 * @param keyId
	 */
	async getRecord(keyId) {
		return request(api.workflow.WORK_FLOW_MANAGE + "/trace/recode/" + keyId, METHOD.GET, {page: 1, limit: 99999});
	},


	/**
	 * 审批流程
	 * @param keyId
	 * @param bussinessNo
	 * @return {Promise<AxiosResponse<T>>}
	 */
	async getInfo(keyId, bussinessNo) {
		return request(api.workflow.WORK_INFO + "?keyId=" + keyId + '&bussinessNo=' + bussinessNo, METHOD.GET);
	},

	/**
	 * 驳回
	 * @param keyId
	 * @param result
	 * @return {Promise<AxiosResponse<T>>}
	 */
	async draft(keyId, result) {
		return request(api.workflow.WORK_FLOW_TASK + "/draftProcess/" + keyId, METHOD.GET, result);
	},


	/**
	 * 撤销
	 * @param keyId
	 * @param result
	 * @return {Promise<AxiosResponse<T>>}
	 */
	async revoke(keyId, result) {
		return request(api.workflow.WORK_FLOW_TASK + "/revokeProcess/" + keyId, METHOD.PUT, result);
	},

	/**
	 * 管理员撤回
	 * @param keyId
	 * @param result
	 * @return {Promise<AxiosResponse<T>>}
	 */
	async backlast(keyId, result) {
		return request(api.workflow.WORK_FLOW_TASK + "/backLast/" + keyId, METHOD.GET, result);
	},

	/**
	 * 提交审批
	 */
	async submit(menuId, keyId, toUsers, taskId, isReplace, result) {
		if (!taskId || taskId === 'null') {
			taskId = '';
		}
		let url = api.workflow.WORK_FLOW_MANAGE + '/start/' + menuId + '/' + keyId + '/to/' + toUsers + '?taskId=' + taskId
		// if (isReplace) {
		// 	url += '&isReplace=' + !!isReplace;
		// }
		return request(url, METHOD.PUT, result);
	},

	/**
	 * 提交审批
	 */
	async complete(taskId, result) {
		if (!taskId || taskId === 'null') {
			taskId = '';
		}
		let url = api.workflow.WORK_FLOW_TASK + '/complete/' + taskId + '/to'
		return request(url, METHOD.GET, result);
	},

	// /**
	//  * 管理员回撤
	//  */
	// async adminBack(insuranceId, result) {
	// 	let url = api.workflow.WORK_FLOW_TASK + '/backLast/' + insuranceId
	// 	return request(url, METHOD.GET, result);
	// }
}

export default {dataApi}